<template>
  <div>
    <div class="text-body-1 font-weight-bold">{{ type }}</div>
    <div class="text-body-1">Objekt: {{ name }}</div>
  </div>
</template>

<script>
import { RecIndividual } from '@/rec-cache/rec-cache-individual'

import { Iris } from '@/rec-cache/rec-cache-types'

export default {
  props: {
    asset: {
      type: Object,
      default: () => new RecIndividual(),
    },
  },
  computed: {
    type: function () {
      return this.asset.type.short
    },
    name: function () {
      return this.asset.getValuesByName(Iris.recName)?.[0]?.value || '-'
    },
  },
}
</script>
